export default __webpack_public_path__ + "static/media/darkforest.3adee226.jpeg";